module.exports = __webpack_public_path__ + "static/media/Independent cameras_1.42fd3d2c.png";